import React, { useEffect, useState } from 'react';
import { Header } from './components/Layout/Header';
import { Sidebar } from './components/Layout/Sidebar';
import { MainContent } from './components/Layout/MainContent';
import { BottomNavigation } from './components/Layout/BottomNavigation';
import { FloatingActionButton } from './components/Layout/FloatingActionButton';
import { LoginDialog } from './components/Auth/LoginDialog';
import { InteractiveDesignDialog } from './components/Dialogs/InteractiveDesignDialog';
import { FiberTopologyDialog2 } from './components/Dialogs/FiberTopologyDialog2';
import { AddCableDialog } from './components/Dialogs/AddCableDialog';
import { useAuthStore } from './stores/authStore';
import './App.css';

function App() {
  const { isAuthenticated, checkAuth } = useAuthStore();
  const [showLogin, setShowLogin] = useState(false);
  const [showInteractiveDesign, setShowInteractiveDesign] = useState(false);
  const [showFiberTopology2, setShowFiberTopology2] = useState(false);
  const [showAddCable, setShowAddCable] = useState(false);

  useEffect(() => {
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run once on mount

  useEffect(() => {
    // Show login dialog if not authenticated
    if (!isAuthenticated) {
      setShowLogin(true);
    } else {
      setShowLogin(false);
    }
  }, [isAuthenticated]);

  // If not authenticated, show only login dialog
  if (!isAuthenticated) {
    return (
      <div className="app">
        <div className="login-required-overlay">
          <div className="login-required-content">
            <h1>🔐 GPON Sieť</h1>
            <p>Pre prístup k aplikácii sa musíte prihlásiť.</p>
            <button
              className="btn-primary-large"
              onClick={() => setShowLogin(true)}
            >
              Prihlásiť sa
            </button>
          </div>
        </div>
        <LoginDialog
          isOpen={showLogin}
          onClose={() => {}} // Cannot close if not authenticated
        />
      </div>
    );
  }

  return (
    <div className="app">
      <Header />
      <div className="app-body">
        <Sidebar />
        <MainContent />
      </div>
      <BottomNavigation />
      <FloatingActionButton
        onFiberTopologyClick={() => setShowFiberTopology2(true)}
        onInteractiveDesignClick={() => setShowInteractiveDesign(true)}
        onAddCableClick={() => setShowAddCable(true)}
      />
      <InteractiveDesignDialog
        open={showInteractiveDesign}
        onClose={() => setShowInteractiveDesign(false)}
      />
      <FiberTopologyDialog2
        open={showFiberTopology2}
        onClose={() => setShowFiberTopology2(false)}
      />
      <AddCableDialog
        isOpen={showAddCable}
        onClose={() => setShowAddCable(false)}
        cable={null}
      />
    </div>
  );
}

export default App;
